import React, { useEffect } from "react";
import { useTheme } from "./ThemeContext";
 
const ThemeWrapper = ({ children }) => {
  const { theme } = useTheme();
 
  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);
 
  return <>{children}</>;
};
 
export default ThemeWrapper;